// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'upload';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 13.5V1M6.188 4 9 1.187 11.813 4M.563 17.436h16.875'
  />
);

export const viewBox = '0 0 18 18';
